/**
 * Google Ads 转化跟踪工具
 * 处理 affiliate link 点击时的转化事件
 */

/**
 * 触发 Google Ads 转化事件
 * @param {string} sendTo - Google Ads 转化 ID (格式: AW-XXXXXXXXXX/XXXXXXXXXX)
 * @returns {Promise<void>}
 */
const triggerConversionEvent = (sendTo) => {
  return new Promise((resolve, reject) => {
    try {
      // 检查 gtag 是否存在
      if (typeof window.gtag !== 'function') {
        console.warn('[Conversion Tracking] gtag is not available');
        reject(new Error('gtag not available'));
        return;
      }

      // 触发转化事件
      window.gtag('event', 'conversion', {
        'send_to': sendTo,
        'event_callback': () => {
          console.log('[Conversion Tracking] Conversion event sent successfully');
          resolve();
        }
      });

      // 设置超时保护，防止 event_callback 永远不被调用
      setTimeout(() => {
        console.log('[Conversion Tracking] Event callback timeout, resolving anyway');
        resolve();
      }, 1000); // 1秒超时

    } catch (error) {
      console.error('[Conversion Tracking] Error triggering conversion event:', error);
      reject(error);
    }
  });
};

/**
 * 处理 affiliate link 点击事件
 * 先触发转化事件，然后跳转到目标链接
 * 
 * @param {Event} event - 点击事件对象
 * @param {string} affiliateLink - affiliate 链接
 * @param {string} conversionId - Google Ads 转化 ID (默认: AW-17839706722/Is9WCKfN--gbEOKk0bpC)
 */
export const handleAffiliateLinkClick = async (event, affiliateLink, conversionId = 'AW-17839706722/Is9WCKfN--gbEOKk0bpC') => {
  // 阻止默认跳转行为
  event.preventDefault();

  console.log('[Conversion Tracking] Affiliate link clicked:', affiliateLink);

  try {
    // 尝试触发转化事件
    await triggerConversionEvent(conversionId);
    console.log('[Conversion Tracking] Conversion event completed, redirecting...');
  } catch (error) {
    // 即使转化事件失败，也要继续跳转
    console.warn('[Conversion Tracking] Conversion event failed, but will redirect anyway:', error);
  } finally {
    // 无论转化事件成功与否，都要跳转到 affiliate link
    // 使用 window.location.href 进行跳转
    window.location.href = affiliateLink;
  }
};

/**
 * 创建带转化跟踪的点击处理函数
 * 用于在 React 组件中使用
 * 
 * @param {string} affiliateLink - affiliate 链接
 * @param {string} conversionId - Google Ads 转化 ID (可选)
 * @returns {Function} 点击处理函数
 * 
 * @example
 * const handleClick = createConversionClickHandler(product.affiliateLink);
 * <a href={affiliateLink} onClick={handleClick}>Zum Angebot</a>
 */
export const createConversionClickHandler = (affiliateLink, conversionId) => {
  return (event) => {
    handleAffiliateLinkClick(event, affiliateLink, conversionId);
  };
};

